module.exports = __webpack_public_path__ + "static/media/bgModal.3fb8bb10.png";